import { IFVContainer } from 'pages/ferramentaVideo/interfaces/FVContainer.interface';
import { GenericService } from '../Generic.service';
import { IFVPackage } from 'pages/ferramentaVideo/interfaces/FVPackage.interface';
import { IFVPackageUnit } from 'pages/ferramentaVideo/interfaces/FVPackageUnit.interface';
import { IFVContents } from 'pages/ferramentaVideo/interfaces/FVContents.interface';
import { IFVRoleAction } from 'pages/ferramentaVideo/interfaces/FVRole.interface';

export class FerramentaVideoService extends GenericService {
    readonly URI: string = '/v1/ferramenta-video';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    async insertContainer(data: IFVContainer) {
        return this.post('', data);
    }

    async updateFerramentaVideo(data: IFVContainer) {
        return this.put(`${data.id}`, data);
    }

    async deleteFerramentaVideo(id: number) {
        return this.delete(id);
    }

    async fetchContainer() {
        return this.get(``);
    }
    async fetchContainersBySolutionId(solutionId: number) {
        return this.get(`public/solucao/${solutionId}`);
    }

    async fetchContainerById(id: number) {
        return this.get(`container/${id}`);
    }

    async fetchPackageById(id: number) {
        return this.get(`package/${id}`);
    }

    async createPackage(id: number, data: IFVPackage) {
        return this.post(`package/${id}`, data);
    }

    async updatePackage(id: number, data: IFVPackage) {
        return this.put(`package/${id}`, data);
    }

    async deletePackage(packageId: number) {
        return this.deleteByUrl(packageId, 'package');
    }

    async fetchPackageUnitById(idPackage: number) {
        return this.get(`package-unit/${idPackage}`);
    }
    async fetchPackageUnitByIdUnit(idUnit: number) {
        return this.get(`package-unit/fetch/${idUnit}`);
    }

    async createPackageUnit(idPackage: number, data: IFVPackageUnit) {
        return this.post(`package-unit/${idPackage}`, data);
    }

    async updatePackageUnit(idPackageUnit: number, data: IFVPackageUnit) {
        return this.put(`package-unit/${idPackageUnit}`, data);
    }

    async deletePackageUnit(idPackageUnit: number) {
        return this.deleteByUrl(idPackageUnit, 'package-unit');
    }

    async createContent(idUnit: number, data: IFVContents) {
        return this.post(`content/${idUnit}`, data);
    }

    async updateContent(idContent: number, data: IFVContents) {
        return this.put(`content/${idContent}`, data);
    }

    async deleteContent(idContent: number) {
        return this.deleteByUrl(idContent, 'content');
    }

    async addVideoContent(idContent: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        return this.postFormData(`content/video/${idContent}`, formData);
    }

    async createRole(idContainer: number, data: IFVRoleAction) {
        return this.post(`role/${idContainer}`, data);
    }

    async updateRole(idRole: number, data: IFVRoleAction) {
        return this.put(`role/${idRole}`, data);
    }

    async deleteRole(idRole: number) {
        return this.deleteByUrl(idRole, 'role');
    }

    async getFerramenta(url: string) {
        return this.get(`public/${url}`);
    }

    async fetchRolesByContainerId(id: number) {
        return this.get(`role/container/${id}`);
    }
}
